import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';
import { Button } from 'react-bootstrap';
import Flex from '../Flex';

export const AdvanceTablePagination = ({
  canPreviousPage,
  canNextPage,
  previousPage,
  nextPage,
  pageCount,
  pageIndex,
  gotoPage
}) => {
  const totalPages = Array.from(Array(pageCount).keys());
  const visiblePages = totalPages.slice(Math.max(0, pageIndex - 2), Math.min(pageCount, pageIndex + 3));
  
  const renderPageButton = (page) => (
    <Button
      key={page}
      size="sm"
      variant="falcon-default"
      className={classNames('page', { 'me-2': page !== totalPages[totalPages.length - 1] })}
      onClick={() => gotoPage(page)}
      style={{ color: pageIndex === page ? 'blue' : '' }}
    >
      {page + 1}
    </Button>
  );


  return (
    <Flex alignItems="center" justifyContent="center">
      <Button
        size="sm"
        variant="falcon-default"
        onClick={() => previousPage()}
        className={classNames({ disabled: !canPreviousPage })}
      >
        <FontAwesomeIcon icon="chevron-left" />
      </Button>
      <ul className="pagination mb-0 mx-2">
        {pageIndex > 2 && (
          <>
            {renderPageButton(0)}
            {pageIndex > 3 && <span className='pe-2'>...</span>}
          </>
        )}
        {visiblePages.map((page) => renderPageButton(page))}
        {pageIndex < pageCount - 3 && (
          <>
            {pageIndex < pageCount - 4 && <span className='pe-2'>...</span>}
            {renderPageButton(pageCount - 1)}
          </>
        )}
      </ul>
      <Button
        size="sm"
        variant="falcon-default"
        onClick={() => nextPage()}
        className={classNames({ disabled: !canNextPage })}
      >
        <FontAwesomeIcon icon="chevron-right" />
      </Button>
    </Flex>
  );
};

export default AdvanceTablePagination;
